import { SEVERITY } from "helpers/utils.js";
import {
  GET_PRODUCT_UNIT_OF_MEASUREMENTS,
  GET_PRODUCT_UNIT_OF_MEASUREMENTS_SUCCESS,
  GET_PRODUCT_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS,
  GET_PRODUCT_UNIT_OF_MEASUREMENTS_ERROR,
  PRODUCT_UNIT_OF_MEASUREMENT_CLEAR_ERROR,
  GET_PRODUCT_UNIT_OF_MEASUREMENT_BY_ID,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const Category = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PRODUCT_UNIT_OF_MEASUREMENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_PRODUCT_UNIT_OF_MEASUREMENTS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        item: null,
        loading: false,
      };
    case GET_PRODUCT_UNIT_OF_MEASUREMENT_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_PRODUCT_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_PRODUCT_UNIT_OF_MEASUREMENTS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case PRODUCT_UNIT_OF_MEASUREMENT_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default Category;
